import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { fileAPI } from '../../../entities/file/api/api';
import { useAppDispatch } from '../redux';
import { RootState } from '../../../redux/reducers/reducer';
import Utils from '../Editor/utils/impl/Utils';
import { setCreateModuleWindowPreviewId } from '../../../entities/module/private-template-module/model/slice';

export const useModulePreview = () => {
	const dispatch = useAppDispatch();
	const preview = useSelector((state: RootState) => state.moduleWindow.createTemplateWindowPreview);
	const previewId = useSelector((state: RootState) => state.moduleWindow.createTemplateWindowPreviewId);
	const [imageUrl, setImageUrl] = useState<string | null>(null);
	const [isImageLoading, setIsImageLoading] = useState(true);
	const [uploadPreview] = fileAPI.useSavePreviewMutation();

	const savePreview = async () => {
		if (!preview) return;

		try {
			const response = await uploadPreview({ name: '', bytes: preview }).unwrap();
			dispatch(setCreateModuleWindowPreviewId(response.id));
		} catch (error) {
			console.error('Ошибка при загрузке превью', error);
		}
	};

	useEffect(() => {
		if (preview) savePreview();
	}, [preview]);

	useEffect(() => {
		if (previewId) {
			setImageUrl(`${Utils.Backend.getSystemImageURI(previewId)}?t=${new Date().getTime()}`);
		}
	}, [previewId]);

	return {
		imageUrl,
		isImageLoading,
		setIsImageLoading,
	};
};
